import { CloseIcon } from '@chakra-ui/icons';
import { Box, Flex, Modal, ModalBody, ModalContent, ModalOverlay, Stack } from '@chakra-ui/react';
import Button, { ButtonVariants } from '@components/interactive/Button';
import Header from '@components/typography/Header';
import { antlerStyle } from '@constants/styles';
import { useEffect, useState } from 'react';

function CtaWrapper({ header, renderCta }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => setIsOpen(false);

  const handleExitIntent = (e) => {
    // Check if mouse exits viewport
    if (e.clientY <= 0 || e.clientX <= 0 || e.clientX >= window.innerWidth || e.clientY >= window.innerHeight) {
      // Only show exit modal once per session
      const exitModalShown = window.sessionStorage.getItem('exitModalShown');
      if (!exitModalShown) {
        // Display modal on a slight delay, update sessionStorage
        setTimeout(() => setIsOpen(true), 1000);
        window.sessionStorage.setItem('exitModalShown', 'true');
      }
    }
  };

  // Exit Modal Intent Listener
  useEffect(() => {
    window.addEventListener('mouseout', handleExitIntent);
    return () => window.removeEventListener('mouseout', handleExitIntent);
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} onClose={handleClose} isCentered>
        <ModalOverlay />
        <ModalContent
          borderRadius={0}
          background="white"
          border={antlerStyle.border}
          borderColor="red.400 !important"
          id="exit_intent_modal"
          maxWidth="600px"
          paddingY={4}
        >
          <ModalBody>
            <Stack spacing={4}>
              <Flex w="100%" alignItems="center" justifyContent="space-between">
                <Header as="h3">{header}</Header>
                <CloseIcon onClick={handleClose} />
              </Flex>

              {renderCta()}
              <Button variant={ButtonVariants.tertiary} marginTop={2} onClick={handleClose}>
                Continue Reading
              </Button>
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Box background="white" border={antlerStyle.border} borderColor="red.400 !important" padding={[6, 6, 8]}>
        <Box alignItems="baseline" display="flex" justifyContent="space-between" pb={4}>
          <Header as="h3">{header}</Header>
        </Box>
        {renderCta()}
      </Box>
    </>
  );
}

export default CtaWrapper;
